<template>
  <div class="jss-loading" v-if="visible">
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  props: {
    delay: {
      type: Number,
      default: 300,
    },
  },
  created() {
    // Wait {this.delay}ms before making the loading graphic visible.
    // If whatever other async operation completes within that timeframe,
    // then whichever parent component invoked the loading component will
    // presumably re-render without the loading component.
    // This helps prevent the loading graphic from too briefly "flashing" on the screen
    // causing an undesirable flicker for users.
    setTimeout(() => {
      this.visible = true;
    }, this.delay);
  },
};
</script>

<style scoped>
.jss-loading {
  display: block;
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  text-align: center;
}

path,
rect {
  fill: #e11f27;
}

path {
  stroke: #222;
  stroke-width: 10;
  stroke-miterlimit: 1;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 5s;
  fill-opacity: 0;
}

path.border,
path.JSS,
path.Logo {
  stroke-dasharray: 26000;
  animation-name: draw;
  animation-delay: 0s;
}

path.slogan {
  stroke-dasharray: 2000;
  animation-name: draw-slogan;
  animation-delay: 0s;
}

@keyframes draw-slogan {
  0% {
    stroke-dashoffset: 2000;
    fill-opacity: 0;
  }
  50% {
    stroke-dashoffset: 0;
    stroke-dasharray: 0;
    fill-opacity: 0.75;
  }
  100% {
    stroke-dashoffset: 2000;
    fill-opacity: 0;
  }
}

@keyframes draw {
  0% {
    stroke-dashoffset: 26000;
    fill-opacity: 0;
  }
  50% {
    stroke-dashoffset: 5000;
    stroke-width: 1;
    fill-opacity: 0.75;
  }
  100% {
    stroke-dashoffset: 26000;
    fill-opacity: 0;
  }
}
</style>
